import { DataGridPro, GridValueGetterParams } from "@mui/x-data-grid-pro";
import { Link } from "react-router-dom";
import { useGetJobsList } from "../../backend/hooks/execution/queryGetJobsList";
import { PmxActivity } from "../../backend/types";
import { useAuth } from "../authContextProvider";
import { customFilters } from "../../helpers/tableViewHelper";
import ScheduleSendOutlinedIcon from "@mui/icons-material/ScheduleSendOutlined";
import {
  convertLocalTimeZone,
  getStatusIcon,
  getStatusTitle
} from "./executionHelpers";
import { useGetMyPmxActivitiesLazyQuery } from "../../backend/hooks/pmxActivity/queryGetMyPmxActivities";
import { useEffect } from "react";
import { Job } from "../../backend/executionTypes";
import Error from "../abstractComponents/error";

export function LandingPageExecutionJobs({
  activityId,
  myExecutionJobs = true
}: {
  activityId?: number;
  myExecutionJobs?: boolean;
}) {
  const { decodedToken } = useAuth();
  const { jobList, isGetJobsListLoading, errorGetJobsList } = useGetJobsList(
    activityId,
    50,
    null,
    myExecutionJobs ? decodedToken["email"] : undefined
  );

  const { getMyPmxActivities, activities, errorActivities } =
    useGetMyPmxActivitiesLazyQuery();

  useEffect(() => {
    if (jobList?.getJobs?.jobs?.length > 0) {
      getMyPmxActivities({
        variables: {
          ids: jobList?.getJobs?.jobs?.map((job: Job) => job.activityId)
        }
      });
    }
  }, [jobList]);

  const columns = [
    {
      field: "id",
      headerName: "ID",
      flex: 1,
      filterOperators: customFilters(true),
      renderCell: (params: GridValueGetterParams) => (
        <Link
          className="execution_link"
          data-executionname={params.row.name}
          to={`/activity/${params.row.activityId}/execution/${params.row.id}`}
          target="_blank"
        >
          <ScheduleSendOutlinedIcon />
          {params.row.id}
        </Link>
      )
    },
    { field: "name", headerName: "Job Name", flex: 1 },
    {
      field: "status",
      headerName: "Status",
      flex: 1,
      renderCell: (params: GridValueGetterParams) => (
        <div key={params.row.id}>
          {getStatusIcon(params.row.status)} {getStatusTitle(params.row.status)}
        </div>
      )
    },
    {
      field: "createdAt",
      headerName: "Created At",
      flex: 1,
      renderCell: (params: GridValueGetterParams) => (
        <div className="executions-created-at">
          {convertLocalTimeZone(params.row.createdAt)}
        </div>
      )
    },
    { field: "createdBy", headerName: "Created By", flex: 1 },
    {
      field: "activityId",
      headerName: "Activity",
      flex: 1,
      renderCell: (params: GridValueGetterParams) => {
        const activity = activities?.getMyPmxActivities?.find(
          (activity: PmxActivity) =>
            Number(activity.id) === Number(params.row.activityId)
        );
        return (
          <Link
            className="activity_link"
            to={`/activity/${params.row.activityId}`}
          >
            {activity?.trialNumber ?? params.row.activityId}
          </Link>
        );
      }
    }
  ];

  return (
    <>
      <DataGridPro
        rows={jobList?.getJobs?.jobs ? jobList?.getJobs?.jobs : []}
        columns={columns}
        pageSize={10}
        rowHeight={60}
        getRowId={(row) => row.id}
        autoHeight
        disableSelectionOnClick
        className="choose_execution_list"
        loading={isGetJobsListLoading}
      />
      {(errorGetJobsList || errorActivities) && (
        <Error error={errorGetJobsList || errorActivities} />
      )}
    </>
  );
}
